import React, {useState, useMemo} from 'react';
import { useEffect } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { _setExternalSourceIframeOpen } from '../../../GlobalState/Actions/actions';
import lodash from 'lodash';

import useTranslation from "../../../../Hooks/UseTranslation/use-translation";

import Loader from "../../../../Components/Shared/Loader";
import Modal from '../../../../Components/Shared/Modal';

import './externalLinkIframe.scss';

interface IExternalLinkIframeParams {
    showModalWithIframe: boolean, 
    onExitClicked: ()=>void, 
    windowBackHandler?: ()=>void, 
    onModalOpenHandler?: ()=>void, 
    modalIframeSrc: {
        current: {
            header?: string,
            url: string,
        }
    }
}

export const ExternalLinkIframe = ({showModalWithIframe, onExitClicked, modalIframeSrc, windowBackHandler, onModalOpenHandler}:IExternalLinkIframeParams) => {
    const [iframeIsLoading, _setIframeIsLoading] = useState(false);
    const dispatch = useDispatch();
    const store = useStore();
    const { t } = useTranslation();
    
    useEffect(() => {
        if(showModalWithIframe){
            _setIframeIsLoading(true);
        }
        else{  
            const externalSourceIframeOpen = lodash.get(store.getState(), "ExternalSourceIframeOpen", false)
            if(externalSourceIframeOpen && !windowBackHandler){
              dispatch(_setExternalSourceIframeOpen(false))
            }
        }
    },[showModalWithIframe])

    const dispatchExternalLinkIframeOpen = () => {
        if(showModalWithIframe){
            dispatch(_setExternalSourceIframeOpen(true));
        }
    }
    
    return(
        useMemo(() => (
        <Modal 
            isOpen={showModalWithIframe} 
            onExitClicked={onExitClicked} 
            modalContainerOverlay={"external-url-modal-overlay"}
            showCloseButton={true}
            heading={modalIframeSrc.current.header ? t(`${modalIframeSrc.current.header}`) : undefined}
            modalContainerClassName={"external-modal-container"}
            modalBodyContainerClassName={"external-modal-container-body"}
            backKeyToCloseModal = {true}
            onModalOpenHandler = {onModalOpenHandler || dispatchExternalLinkIframeOpen}
            windowBackHandler = {windowBackHandler || onExitClicked}
            >
            <>
            {iframeIsLoading && 
                <Loader 
                smallLoader={true}
                loaderDivClass="external-url-iframe-loader"
                loaderImgClass="external-url-iframe-loader"
                />
            }
            {showModalWithIframe &&
                <iframe className="external-url-iframe" src={modalIframeSrc.current.url} onLoad={()=>{_setIframeIsLoading(false)}}/>
            }
            </>
        </Modal>
        ),[showModalWithIframe, iframeIsLoading, modalIframeSrc.current.url])
    )
}